export async function generateDynamicSignature(data) {
  const timestamp = Math.floor(Date.now() / 1000).toString();

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const nonce = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  const bodyString = data ? JSON.stringify(data) : "";
  const payload = `${timestamp}${nonce}${bodyString}`;

  const encoder = new TextEncoder();
  const keyBuffer = encoder.encode(process.env.REACT_APP_SECRET_KEY);
  const dataBuffer = encoder.encode(payload);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const signatureBuffer = await crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    dataBuffer
  );

  const signature = Array.from(new Uint8Array(signatureBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return { signature, timestamp, nonce };
}
